import { MY_ACCESS } from "../statics/localStorage";

export const accessCheck = (accessId) => {
    let arr = (MY_ACCESS())
    let result = arr?.accessCodes?.includes(accessId);
    return result;
}